<!-- Intro Header -->
<header class="sdg-status">
  <div class="intro-body">
    <div class="container">
      <div class="row" appDynamicDirection>
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-6 title">
              <h4 class="page-heading">Water-Related Sustainable Development Goals</h4>
              <h2 class="intro-text" i18n>Gender - Resources</h2>
            </div>
            <div class="col-sm-6">
              <a class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px; background: #1f487c;">
                <span i18n>Resources</span>
              </a>
              <a (click) = "quesBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center " style="margin-bottom: 15px;">
                <span i18n>Questionnaire</span>
              </a>
              <a (click) = "dataBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px;">
                <span i18n>Data</span>
              </a>
              <a (click) = "reportBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center" style="margin-bottom: 15px;">
                <span i18n>Reporting</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<section class="content-section">
    <mat-table #table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="column1">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Tool/Resource </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column1}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column2">
              <mat-header-cell *matHeaderCellDef> Link to tool/resource </mat-header-cell>
              <mat-cell *matCellDef="let element"> <a href= {{element.column2}}>Link</a> </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column3">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Data source  </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column3}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="column4">
              <mat-header-cell *matHeaderCellDef> Link to data source </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.column4}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column5">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Indicator number in tool/resource </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column5}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column6">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Used in SDG-PSS </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column6}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="column7">
              <mat-header-cell *matHeaderCellDef> Indicator title </mat-header-cell>
              <mat-cell *matCellDef="let element">  {{element.column7}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="column8">
              <mat-header-cell *matHeaderCellDef> Measure/Question/Sub-indicator</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.column8}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
  <!-- <table class="table table-striped resources-table" >
    <thead>
      <tr class="row-name ">
        <th class="text-center">Theme/Source</th>
        <th class="text-center">Link to Tool and recomended indicator</th>
        <th class="text-center">International data sources</th>
        <th class="text-center">Link to international level<br> data used in 2017</th>
        <th class="text-center">Indicator number</th>
        <th class="text-center">Used in generic PSS?</th>
        <th class="text-center">Suggested Indicator</th>
        <th class="text-center">Measure/Question/Sub-indicator</th>
      </tr>
    </thead>
    <tbody class="text-center">
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1j</td>
        <td>Yes</td>
        <td>Water Governance: The presence and nature of gender-specific  objectives and commitments  (or gender strategy) in national- and sector-level water policies.</td>
        <td><i>> Are specific gender objectives articulated within all key national policies and strategies for this target/indicator?</i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1k</td>
        <td>No</td>
        <td>Water Governance: The nature and extent of sex-disaggregated data related to water and sanitation collected by responsible public entities at national and local levels (in relation to the totality of social indicators on water and sanitation collected).</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1i</td>
        <td>No</td>
        <td>Water Governance: The extent to which gender outcomes and gender-sensitive accountability indicators are included in M&amp;E/impact statements/benefits  analyses of national-level  water-sector  projects (project  proposals and/or  outcomes assessments). Sample projects.</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1h</td>
        <td>Yes</td>
        <td>Water Governance: Presence and nature of gender-sensitive  training  within  responsible ministries/lead agencies; Participation of M/F staff.</td>
        <td><i>>Is there gender sensitivity training within lead Ministries/Institutions at least once a year?</i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1a</td>
        <td>Yes</td>
        <td>Water Governance: Number of male and female (M/F) paid staff in public water-governance agencies, disaggregated by job category/level and decision-making capacity (and salary, if available), at:- national level; county/state levels/ and town/village levels</td>
        <td><i>>What are the proportions of female and male paid staff in the lead Ministry/Agency for this target/indicator, disaggregated by job category/level and decision-making capacity?</i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1e</td>
        <td>No</td>
        <td>Water Governance: Number of M/F staff responsible for water issues (disaggregated  by job level) in gender ministry/lead  agency.</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1f</td>
        <td>Yes</td>
        <td>Water Governance: Number of M/F staff responsible for gender issues (disaggregated  by job level) in lead agency for the water sector.</td>
        <td><i>>How many staff are responsible for gender issues in the lead Ministry/ Agency for this target/indicator?</i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1b</td>
        <td>No</td>
        <td>Water Governance: Number of M/F in paid and unpaid  positions in local water governance formally-structured entities (water users associations, etc.) at town/village level (sample); disaggregated by nature of relationship to the entity (e.g. “member”, “board”, “executive”, “leadership,” decision-making group, etc.) and types of tasks.</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1d</td>
        <td>No</td>
        <td>Water Governance: M/F perceptions of gender discrimination (or equality) regarding women’s participation in decision-making entities.</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1c</td>
        <td>Yes</td>
        <td>Water Governance: Intensity of M/F participation  in (sample/representative) meetings of public entity bodies sampled at national, sub-national, and local levels, including outcomes such as: ratio of contributions  in decision-making meetings by women and men; percentage of decisions adopted from women’s contributions in meetings.</td>
        <td><i>>What was the intensity of male and female participation in at least three national-level meetings of Government and public bodies for this target/indicator this year?</i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1g</td>
        <td>Yes</td>
        <td>Water Governance: Designated ministerial responsibility for gender in relation to water policies; the extent to which gender-specific agencies are included in water sector decision-making.</td>
        <td><i>>How often are national gender agency specialists  included in decision-making for this target/indicator?</i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>4c</td>
        <td>No</td>
        <td>Transboundary Water Management: The presence and nature of gender-specific objectives and commitments (or gender strategy) in transboundary agreements.</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>4b</td>
        <td>No</td>
        <td>Transboundary Water Management: The extent to which gender outcomes and gender-sensitive accountability indicators are included in M&amp;E/impact statements/benefits analyses of transboundary agreements/activities.</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>4a</td>
        <td>No</td>
        <td>Transboundary Water Management: Number of M/F staff on transboundary water commissions (sample for pilot countries), disaggregated by job category/level and decision-making capacity (and salary, if available)</td>
        <td></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>4d</td>
        <td>No</td>
        <td>Transboundary Water Management: Intensity of M/F participation in (sample/representative) meetings of transboundary meetings, including outcomes such as: ratio of contributions in decision-making meetings by women and men; percentage of decisions adopted from women’s contributions in meetings.</td>
        <td></td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td><br></td>
        <td>No</td>
        <td>Strengthening the voice of men and women: Ratio of contributions in decision making meetings by women and men</td>
        <td>Are sector meetings at community level organized to overcome cultural barriers to women’s participation, (cultural norms, seating arrangements, language and meeting times)?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td><br></td>
        <td>No</td>
        <td>Strengthening the voice of men and women: Ratio of contributions in decision making meetings by women and men</td>
        <td>Do operational agencies provide information for decision making on policies, strategies, plans and investments, in a format that is user-friendly and accessible to women, marginalized groups and the organizations that represent them?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td><br></td>
        <td>No</td>
        <td>Strengthening the voice of men and women: Ratio of contributions in decision making meetings by women and men</td>
        <td>Do policy makers and regulatory bodies make use of feedback mechanisms for complaints and challenges faced by citizens from their providers, including those on lower levels of service, such as for those relying on stand pipes and kiosks?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td><br></td>
        <td>No</td>
        <td>Strengthening the voice of men and women: Number of policies and strategies published with inputs from non-state actors and marginalized groups</td>
        <td>Do service providers demonstrate commitment to the citizen voice by utilizing tools like citizens’ charters, ICT, satisfaction surveys, toll free lines and effective complaint desks?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td><br></td>
        <td>No</td>
        <td>Strengthening the voice of men and women: Number of policies and strategies published with inputs from non-state actors and marginalized groups</td>
        <td> Is civil society supported in holding service providers and power holders accountable for their performance and behavior? </td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td><br></td>
        <td>No</td>
        <td>Strengthening the voice of men and women:  Number of policies and strategies published with inputs from non-state actors and marginalized groups</td>
        <td>Do agencies allow citizens to influence their plans, budgets and strategies, based on the voices of both women and men?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>2.4</td>
        <td>Yes</td>
        <td>Mainstreaming gender in operations: The impact and effectiveness of activities to promote greater gender equality within the organizational culture of development groups e.g., the impact of affirmative action policies.</td>
        <td>Is there an internal work place gender policy and strategy which takes cognizance of national and sector gender targets?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>2.4</td>
        <td>No</td>
        <td>Mainstreaming gender in operations: The impact and effectiveness of activities to promote greater gender equality within the organizational culture of development groups e.g., the impact of affirmative action policies.</td>
        <td>Is capacity being built for staff to address gender issues in urban and rural water and sanitation programs?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>2.1</td>
        <td>No</td>
        <td>Mainstreaming gender in operations: The impact and effectiveness of activities to promote greater gender equality within the organizational culture of development groups e.g., the impact of affirmative action policies</td>
        <td>Have urban and small utilities adopted services to the poor as a key corporate objective and employed gender trained staff to address the numerous gender issues in poorer areas? </td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td><br></td>
        <td>No</td>
        <td>Mainstreaming gender in operations: Percentage of men and women engaged in initiating, siting, implementing, using, and O&amp;M of WSS</td>
        <td>Is there a national strategy for sanitation in schools, with emphasis on safe, separate, well-maintained facilities for girls and boys?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td><br></td>
        <td>No</td>
        <td>Mainstreaming gender in operations: Percentage of men and women engaged in initiating, siting, implementing, using, and O&amp;M of WSS</td>
        <td>Is there equal participation of men and women at all stages: initiation, design, site location, implementation, price setting, O&amp;M and management?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td><br></td>
        <td>No</td>
        <td>Mainstreaming gender in operations: Percentage increase in income for women and men from productive uses of water</td>
        <td>Are there equal economic opportunities from WSS interventions?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>2.3</td>
        <td>Yes</td>
        <td>Mainstreaming gender in operations:  The impact and effectiveness of activities to promote greater gender equality within the organizational culture of development groups e.g., the impact of affirmative action policies.</td>
        <td>Are performance-based contracts or similar boundaries in place to compel staff to pursue gender mainstreaming objectives and incentives to reward them for doing so? </td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td><br></td>
        <td>No</td>
        <td>Mainstreaming gender in operations:  Percentage of men and women engaged in initiating, siting, implementing, using, and O&amp;M of WSS</td>
        <td>Do implementation and communication strategies inform women and men how to participate equitably in all phases of the WSS cycle? </td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1.1</td>
        <td>No</td>
        <td>Mainstreaming gender at policy level: Water and sanitation equity distribution ratios and percentage of population on-network vs. off-network</td>
        <td>Does sector policy address barriers facing both men and women in making productive use of water e.g. for household, livestock, drip irrigation or cottage industries?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1.8</td>
        <td>Yes</td>
        <td>Mainstreaming gender at policy level: The existence of gender specific objectives within national and sector level policies.</td>
        <td>Has gender analysis been undertaken to inform national policy responses to gender issues in the water and sanitation sector at country level?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1.5</td>
        <td>Yes</td>
        <td>Mainstreaming gender at policy level: The existence of gender specific objectives within national and sector level policies.</td>
        <td>Are specific gender objectives articulated within national water and sanitation policies and strategies?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1.4</td>
        <td>Yes</td>
        <td>Mainstreaming gender at policy level: The existence of gender specific objectives within national and sector level policies.</td>
        <td>Do policies address issues in women’s participation and representation and target pockets of vulnerability to promote equity?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1.7</td>
        <td>Yes</td>
        <td>Mainstreaming gender at policy level: The existence of gender policies within agencies involved in sector development.</td>
        <td>Has an institutional audit been done to identify gaps in lead ministry capacity and practice, in responding to gender issues?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1.2</td>
        <td>Yes</td>
        <td>Mainstreaming gender at policy level: The existence of gender policies within agencies involved in sector development.</td>
        <td>Do the lead water and sanitation sector ministries and its appointed agencies allocate resources for gender mainstreaming activities?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1.1</td>
        <td>Yes</td>
        <td>Mainstreaming gender at policy level: The existence of gender policies within agencies involved in sector development.</td>
        <td>Do sector agencies operating at the national level, have gender policies to align and inform their investment and do they support national government to fulfill mainstreaming policy goals?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>1.3</td>
        <td>Yes</td>
        <td>Mainstreaming gender at policy level: The existence of gender policies within agencies involved in sector development.</td>
        <td>Do national level stakeholders (government, donors, civil society, research agencies) regularly incorporate gender considerations in studies, reviews or research commissioned to progress sector goals?</td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>3d</td>
        <td>No</td>
        <td>Decision-Making and Knowledge production: M/F perceptions of/knowledge  of current total household use of water, by category of use and by primary user.</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>3g</td>
        <td>No</td>
        <td>Decision-Making and Knowledge production: M/F perceptions of household gender equality in water decisions</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td height="105" bgcolor="#FFFFFF">><br></td>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>3a</td>
        <td>No</td>
        <td>Decision-Making and Knowledge production: M/F participation  in past decade of two major global international water meetings (and nationally-significant  comparable meetings):• World Water Week (Stockholm)• World Water Forum (World Water Council)</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>3b</td>
        <td>Yes</td>
        <td>Decision-Making and Knowledge production: M/F inclusion on nationally and internationally  convened scientific panels and advisory boards</td>
        <td><i>What is the proportion of female and male representation on all national and international scientific or advisory boards that exist for this target/indicator?</i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>3f</td>
        <td>No</td>
        <td>Decision-Making and Knowledge production: M/F expressed priorities  for water use within households.</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>3e</td>
        <td>No</td>
        <td>Decision-Making and Knowledge production: Household member primarily responsible for managing the household water:<br>• M/F perceptions of the nature of their household decision-making  process for water priorities and use;<br>• M/F perceptions of the primary decision-maker  on water issues within  the household (if any); and<br>• M/F perceptions of how intra-household conflicts related to water (if any) are resolved.</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>Gender Toolkit of the United Nations WWAP Working Group on Gender Sensitive Water Monitoring, Assessment and Reporting </td>
        <td>http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/SC/pdf/Sex_disaggregated_indicators_for_water_assessment_monito.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>3c</td>
        <td>No</td>
        <td>Decision-Making and Knowledge production: Gender audit  of WHO/UNICEF JMP (could be topic specific or region specific).</td>
        <td><i><br></i></td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>2.5</td>
        <td>Yes</td>
        <td> Mainstreaming gender in operations: The impact and effectiveness of activities to promote greater gender equality within the organizational culture of development groups e.g., the impact of affirmative action policies.</td>
        <td>Is there institutional awareness and commitment to promote equality in representation between women and men in the water agency; equal compensation for equal work, and equal opportunities for training?</td>
      </tr>
      <tr>
        <td>World Bank Water and Sanitation Programme Gender Checklist</td>
        <td>https://www.wsp.org/sites/wsp.org/files/publications/WSP-gender-water-sanitation.pdf</td>
        <td>None found</td>
        <td>None</td>
        <td>2.2</td>
        <td>Yes</td>
        <td> Mainstreaming gender in operations: The impact and effectiveness of activities to develop gender awareness and skills amongst policy-making, management and implementation staff.</td>
        <td>Are resources allocated to implement gender strategies (e.g. participatory approaches, gender assessments, specially targeted projects) within agency service activities? </td>
      </tr>
    </tbody>
  </table> -->
</section>



// WEBPACK FOOTER //
// ./src/app/sdg/gender/gender.component.html